import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { SubSink } from './core/subsink';

import { FuseSplashScreenService } from '@fuse/services/splash-screen';
import { SettingsService } from './core/services/settings/settings.service';
import { BadisOauthLoginService } from './core/services/auth/badis-oauth-login.service';
import { SettingsModel } from './core/services/settings/dtos/settings-model';
import { NGXLogger, NgxLoggerLevel } from 'ngx-logger';
import { fuseAnimations } from '@fuse/animations';
import { LoggerMonitor } from './shared/services/logger-monitor.service';


import { DeviceHubConnectionService } from './core/services/hubs/device-hub-connection.service';
import { PropertyHubConnectionService } from './core/services/hubs/property-hub-connection.service';
import { LocationHubConnectionService } from './core/services/hubs/location-hub-connection.service';
import { SystemHubConnectionService } from './core/services/hubs/system-hub-connection.service';
import { AlertHubConnectionService } from './core/services/hubs/alert-hub-connection.service';
import { PostOfficeService } from './core/services/post-office/post-office.service';
import { LanguageService } from './shared/services/language.service';
import { LiveDTO } from './modules/live/dtos/live';
import { NotificationService } from './pages/notifications/services/notification.service';
import { Title } from '@angular/platform-browser';
import { UpdateCheckService } from './shared/services/update-check.service';
import { BackgroundService } from '@app/shared/components/background/background.service';
import { GlobalVariablesService } from './core/services/global-variables.service';
import { HighlightService } from './shared/services/highlight.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import calendar from 'dayjs/plugin/calendar';
import localeData from 'dayjs/plugin/localeData';
import duration from 'dayjs/plugin/duration';
import isLeapYear from 'dayjs/plugin/isLeapYear';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/tr' // import locale
import { MaintenanceHubConnectionService } from './core/services/hubs/maintenance-hub-connection.service';
import { Maintenance } from './core/services/hubs/models/maintenance.model';
import { ServiceName, ServiceReadyStateService } from './core/services/service-ready-state.service';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { ToastNotifyService, TOAST_TIMEOUTS } from './pages/notifications/services/toast-notify.service';
import { NorthernColors } from './shared/components/northern-lights/models';
import { Router } from '@angular/router';

@UntilDestroy()
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild(ToastContainerDirective, { static: true }) toastContainer!: ToastContainerDirective;
    private subs = new SubSink();

    enableAlerts: boolean = false;
    newUpdateAvailable: boolean;
    enablePushAlerts: boolean = false;

    muteCountdown$: Observable<number>;
    NorthernColors = NorthernColors;

    // Toast container hover state
    isToastContainerHovered: boolean = false;
    constructor(
        public library: FaIconLibrary,

        private splash: FuseSplashScreenService,
        private loginService: BadisOauthLoginService,
        private settingService: SettingsService,
        logger: NGXLogger,

        private deviceHub: DeviceHubConnectionService,
        private propertyHub: PropertyHubConnectionService,
        private locationHub: LocationHubConnectionService,
        private systemHub: SystemHubConnectionService,
        private alertHub: AlertHubConnectionService,
        private maintenanceHub: MaintenanceHubConnectionService,
        public backgroundService: BackgroundService,
        private postOfficeService: PostOfficeService,
        languageService: LanguageService,
        public updateCheckService: UpdateCheckService,
        private titleService: Title,
        public toastNotify: ToastNotifyService,
        public notificationService: NotificationService,
        global: GlobalVariablesService,
        private readyStateService: ServiceReadyStateService,
        public toast: ToastrService,
        public highlightService: HighlightService


    ) {

        // dayjs initialization
        dayjs.extend(utc);
        dayjs.extend(timezone);
        dayjs.extend(calendar);
        dayjs.extend(localeData);
        dayjs.extend(duration);
        dayjs.extend(isLeapYear);
        dayjs.extend(advancedFormat);
        dayjs.extend(localizedFormat);


        languageService.init();

        console.log('AppComponent constructor - HighlightService initialized:', this.highlightService);

        this.splash.show();

        this.notificationService.getNotificationsData().subscribe(data => {
            this.updateTitle(data.unreadMessages);
        });

        logger.registerMonitor(new LoggerMonitor());

        this.library.addIconPacks(far);
        this.library.addIconPacks(fal);
        this.library.addIconPacks(fas);

        this.loginService.onAuthStatusChanged.subscribe(async (isAuthenticated: boolean) => {

            if (isAuthenticated && this.loginService.isUserLoggedIn()) {
                await this.pageIsReady();
            } else {

                //redirect to login page with return url
                //this.router.navigate(['/auth', { returnUrl: this.router.url }]);
            }
            this.settingService.refresh();
        });

        this.settingService.settingChanged.subscribe((setting: SettingsModel.Settings) => {
            switch (setting.primaryKey) {
                case 'Performance.Browser.EnableDebug':
                    const enableDebug = setting.primaryValue;

                    console.debug('debug mode:', enableDebug ? 'true' : 'false');
                    const config = logger.getConfigSnapshot();
                    config.level = enableDebug ? NgxLoggerLevel.TRACE : NgxLoggerLevel.ERROR;
                    config.serverLogLevel = NgxLoggerLevel.ERROR;
                    config.disableConsoleLogging = !enableDebug;
                    logger.updateConfig(config);
                    global.isDebugMode = enableDebug;
                    break;
                case 'General.Region.TimeZone':
                    const timeZone = setting.primaryValue || 'Europe/Istanbul';
                    dayjs.tz.setDefault(timeZone);
                    break;
                case 'Notification.Alerts.Enable':
                    this.enableAlerts = setting.getValue<boolean>();
                    break;


                default:
                    break;
            }


            if (setting.changeRequest === LiveDTO.ChangeRequest.User) {

                switch (setting.primaryKey) {


                }
            }


        });





    }



    async pageIsReady() {
        this.postOfficeService.init();
        this.notificationService.handleTokenRefresh();

        // Initialize all hubs
        this.deviceHub.init();
        this.propertyHub.init();
        this.locationHub.init();
        this.systemHub.init();
        this.alertHub.init();
        this.maintenanceHub.init();

        // Start all hub connections
        Promise.all([
            this.deviceHub.startConnection(),
            this.propertyHub.startConnection(),
            this.locationHub.startConnection(),
            this.systemHub.startConnection(),
            this.alertHub.startConnection(),
            this.maintenanceHub.startConnection()
        ]);

        // Set SignalR service as ready
        this.readyStateService.setServiceReady(ServiceName.SignalR, true);

        // Subscribe to alerts after SignalR is ready
        this.alertHub.alertUpdated$
            .pipe(untilDestroyed(this))
            .subscribe((alert) => {
                if (!alert || !this.enableAlerts || this.enablePushAlerts)
                    return;

                this.toastNotify.showAlert(alert);
            });

        this.maintenanceHub.fragmentationProgress$
            .pipe(untilDestroyed(this))
            .subscribe((data) => {
                if (!data)
                    return;

                if (data.status == Maintenance.MaintenanceStatus.Started)
                    this.toastNotify.showMaintenanceAlert(data);
            });

       

    }

    ngOnInit(): void {

        // todo: mesut -> if something goes wrong! delete me
        // this.screenLock.startWatching(5).subscribe((isTimedOut: boolean) => {
        //     if (isTimedOut) {
        //      //   console.log('screen locked! just kidding:) not today but soon');
        //     }
        // });

        this.muteCountdown$ = this.toastNotify.getCountdown();
    }

    private updateTitle(unreadCount: number): void {
        const newTitle = unreadCount > 0 ? `(${unreadCount}) Navizard` : 'Navizard';
        this.titleService.setTitle(newTitle);
    }

    toggleMuteNotifications() {
        this.toastNotify.toggleMute();
    }

    clearNotifications() {
        this.toastNotify.clearNotifications();
    }

    // Toast container hover event handler
    onToastContainerHover(isHovered: boolean) {
        this.isToastContainerHovered = isHovered;
    }

    // Menü görünürlük class'larını belirle - tek mesaj için hover animasyonu
    getMenuVisibilityClass(): string {
        const activeCount = this.toastNotify.activeNotifications;

        if (activeCount === 1) {
            // Tek toast için hover ile smooth fade-in/out
            return this.isToastContainerHovered
                ? 'menu-single-visible'
                : 'menu-single-hidden';
        } else if (activeCount > 1) {
            // Çoklu toast için her zaman görünür
            return 'menu-multi-visible';
        } else {
            // Hiç toast yok
            return 'menu-empty';
        }
    }

    // Toast menüsünün görünürlüğünü kontrol et
    shouldShowToastMenu(): boolean {
        // Tek mesaj varken de DOM'da olsun ama CSS ile gizlensin
        return this.toastNotify.activeNotifications > 0 || this.toastNotify.isMuted;
    }

    // Toast sayısına göre konteyner genişliğini dinamik ayarla - artık gereksiz
    // getToastContainerWidthClass(): string {
    //     return '';
    // }

    // Menü butonlarının hover efektleri için helper
    getToastMenuTooltip(): string {
        const activeCount = this.toastNotify.activeNotifications;

        if (activeCount === 0) {
            return 'No active notifications';
        } else if (activeCount === 1) {
            return '1 notification active';
        } else {
            return `${activeCount} notifications active`;
        }
    }


    ngAfterViewInit(): void {
        this.updateCheckService.checkForUpdates();
        this.toastNotify.setToastContainer(this.toastContainer);
    }


    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    createTestToast() {
        this.toastNotify.createTestToast();
    }

    createMultipleTestToasts() {
        this.toastNotify.createMultipleTestToasts();
    }
}
